export default function validationTransferStock(response, messages) {
  if (!response?.data?.error?.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;

    if (message.indexOf('MODULE_STOCK_NOT_ACTIVATED') === 0) {
      messages.push({
        message: 'validationBonStock.moduleStockNotActivated',
      });
    }

    if (message.indexOf('LIEU_DEPART_EGAL_LIEU_ARRIVE') === 0) {
      messages.push({
        message: 'validationBonStock.lieuDepartEgalLieuArrive',
      });
    }

    if (message.indexOf('LIEU_DEPART_NOT_TIER_ENFANT') === 0) {
      messages.push({
        message: 'validationBonStock.lieuDepartNotTierEnfant',
      });
    }

    if (message.indexOf('LIEU_DEPART_NOT_STOCKAGE') === 0) {
      messages.push({
        message: 'validationBonStock.lieuDepartNotStockage',
      });
    }

    if (message.indexOf('LIEU_ARRIVE_NOT_TIER_ENFANT') === 0) {
      messages.push({
        message: 'validationBonStock.lieuArriveNotTierEnfant',
      });
    }

    if (message.indexOf('LIEU_ARRIVE_NOT_STOCKAGE') === 0) {
      messages.push({
        message: 'validationBonStock.lieuArriveNotStockage',
      });
    }

    if (message.indexOf('QUANTITE_NOT_CORRECT') === 0) {
      messages.push({
        message: 'validationBonStock.quantiteNotCorrect',
      });
    }
    if (message.indexOf('PRODUIT_ACHAT_PAR_DEFAULT') === 0) {
      messages.push({
        message: 'validationBonStock.produitAchatParDefault',
      });
    }

    if (message.indexOf('PRODUIT_VENTE_PAR_DEFAULT') === 0) {
      messages.push({
        message: 'validationBonStock.produitVenteParDefault',
      });
    }
  });
}
